export const removeNewlineCode = (content) => {
  if (!content) return ''
  return content.replace(/\r?\n/g, '')
}
